export const commonValidations = {
    required: true,
    password: (x: string) => x.length >= 8,
    sameAs: (other: string) => (x: any, fields: any) => x === fields[other]?.value,
    email: (x: string) => typeof x === 'string' && /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(x),
    length: (x: string, min?: number, max?: number) => (min ? x.length >= min : true) && (max ? x.length <= max : true),
    noBlanks: (x: string) => !x.includes(' '),
};
